import React from 'react'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_websoft/layout/core'
import PotencijalniKlijenti from './PotencijalniKlijenti'

const ECommerceBreadcrumbs: Array<PageLink> = [
  {
    title: 'E-Commerce',
    path: '/e-commerce/leads',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ECommerceRoutes: React.FC = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='leads'
          element={
            <>
              <PageTitle breadcrumbs={ECommerceBreadcrumbs}>Potencijalni klijenti</PageTitle>
              <PotencijalniKlijenti />
            </>
          }
        />
        <Route index element={<Navigate to='/e-commerce/leads' replace />} />
        <Route path='*' element={<Navigate to='/e-commerce/leads' replace />} />
      </Route>
    </Routes>
  )
}

export default ECommerceRoutes
